import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsersComponent } from './users.component';
import { UsersRoutingModule } from './users-routing.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { FormModule, OverflowMenuModule, SharedModule } from 'components';
import { AddEditUserDialogModule } from './add-edit-user-dialog/add-edit-user-dialog.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AssignDatasetsDialogModule } from './assign-datasets-dialog/assign-datasets-dialog.module';
import { AssignRolesDialogModule } from './assign-roles-dialog/assign-roles-dialog.module';
import { MatPaginatorModule } from '@angular/material/paginator';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [UsersComponent],
  imports: [
    CommonModule, 
    MatIconModule, 
    MatButtonModule, 
    MatTableModule, 
    OverflowMenuModule, 
    UsersRoutingModule, 
    AddEditUserDialogModule, 
    MatProgressSpinnerModule, 
    AssignDatasetsDialogModule, 
    AssignRolesDialogModule, 
    MatPaginatorModule,
    SharedModule,
    FormModule],
  exports: [UsersComponent]
})
export class UsersModule { }
